import AssessmentIcon from "@mui/icons-material/Assessment";
import BarChartIcon from "@mui/icons-material/BarChart";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import HomeIcon from "@mui/icons-material/Home";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import KeyIcon from "@mui/icons-material/Key";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import { Box, Dialog, Link, useMediaQuery, useTheme } from "@mui/material";
import { useAppSelector } from "app/hooks";
import { DialogTitle } from "common";
import NestedSidebarNavigation, {
  NestedSidebarItem,
} from "common/components/Navigation/NestedSidebarNavigation";
import { selectProfile } from "features/profile/profileSlice";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import SidebarShellV2 from "layouts/SidebarV2/SidebarShellV2";
import { useState } from "react";
import PartnerUserMenu from "./PartnerUserMenu";

export interface PartnerSidebarMenuV2Props {
  open?: boolean;
  temporary?: boolean;
  setOpen?: (open?: boolean) => void;
}

export default function PartnerSidebarMenuV2({
  open = false,
  temporary = false,
  setOpen,
}: PartnerSidebarMenuV2Props) {
  const theme = useTheme();
  const profile = useAppSelector(selectProfile);
  const { hasPermissions } = useAccess();
  const [termsOpen, setTermsOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const items: NestedSidebarItem[] = [
    {
      id: "booking-surface",
      label: I18n.t("Sidebar.bookingSurface"),
      path: "/",
      exact: true,
      icon: <HomeIcon />,
    },
    {
      id: "partner-bookings",
      label: I18n.t("Sidebar.bookings"),
      path: "/bookings",
      icon: <KeyIcon />,
    },
    {
      id: "partner-news",
      label: I18n.t("PartnerFeed.newsTitle"),
      path: "/news",
      icon: <RssFeedIcon />,
    },
    {
      id: "partner-reports",
      label: I18n.t("Sidebar.reports"),
      icon: <InsightsRoundedIcon />,
      children: [
        {
          id: "partner-commission-report",
          label: I18n.t("CommissionReport.title"),
          path: "/commission-report",
          icon: <AssessmentIcon />,
          visible: hasPermissions("report.menu_commission"),
        },
        {
          id: "partner-statistics",
          label: I18n.t("Sidebar.statistics"),
          path: "/statistics",
          icon: <BarChartIcon />,
        },
      ],
    },
    {
      id: "partner-contact",
      label: I18n.t("Sidebar.contact"),
      path: "/contact",
      icon: <ContactMailIcon />,
    },
  ];

  return (
    <>
      <SidebarShellV2
        open={open}
        temporary={temporary}
        setOpen={setOpen}
        profileSubtitle={profile.partner_name}
        userMenu={<PartnerUserMenu />}
        beforeProfile={
          <Link
            component="button"
            type="button"
            onClick={() => setTermsOpen(true)}
            color="inherit"
            underline="hover"
            sx={{
              width: "100%",
              minHeight: 40,
              justifyContent: "center",
              fontSize: "0.75rem",
              opacity: 0.8,
            }}
          >
            {I18n.t("Sidebar.terms")}
          </Link>
        }
        navigation={
          <NestedSidebarNavigation
            items={items}
            expanded={open}
            onRequestExpand={() => setOpen?.(true)}
            onNavigate={temporary ? () => setOpen?.(false) : undefined}
          />
        }
      />

      <Dialog
        open={termsOpen}
        onClose={() => setTermsOpen(false)}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{ sx: { height: isMobile ? "100%" : "90vh" } }}
      >
        <DialogTitle onClose={() => setTermsOpen(false)}>
          {I18n.t("Sidebar.terms")}
        </DialogTitle>
        <Box sx={{ flex: 1, overflow: "hidden", position: "relative" }}>
          <iframe
            src="https://silver-line.hu/wp-content/uploads/2025/05/UZLETSZABALYZAT_hun_silver_2025.3.11.pdf"
            style={{ width: "100%", height: "100%", border: "none" }}
            title={I18n.t("Sidebar.terms")}
          />
        </Box>
      </Dialog>
    </>
  );
}
